export default "__VITE_ASSET__BymD9txF__"